module.exports = __webpack_public_path__ + "media/Olamide_Pawon.fdff34a5.mp3";